var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildDataSetHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166382 2.33363C0.166382 1.04475 2.77826 0 6.00001 0C9.22176 0 11.8336 1.04475 11.8336 2.33363V3.5C11.8336 4.78888 9.22176 5.83362 6.00001 5.83362C2.77826 5.83362 0.166382 4.78888 0.166382 3.5V2.33363Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166382 5.54224V8.16724C0.166382 9.45436 2.77826 10.5 6.00001 10.5C9.22176 10.5 11.8336 9.45524 11.8336 8.16636V5.54224C11.4396 5.82609 11.0109 6.05839 10.5579 6.23349C9.33376 6.72349 7.72113 6.99999 6.00001 6.99999C4.27976 6.99999 2.66713 6.72261 1.44301 6.23349C0.990021 6.05841 0.561291 5.82611 0.167257 5.54224H0.166382Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8336 10.2094C11.4395 10.4929 11.0108 10.7249 10.5579 10.8997C9.33288 11.3897 7.72113 11.6662 5.99913 11.6662C4.27888 11.6662 2.66626 11.3897 1.44213 10.8997C0.989154 10.7247 0.560427 10.4924 0.166382 10.2085V11.6662C0.166382 12.9551 2.77826 13.9999 6.00001 13.9999C9.22176 13.9999 11.8336 12.9551 11.8336 11.6662V10.2094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildDataSetHeaderIcon);
export default __webpack_public_path__ + "static/media/buildDataSetHeaderIcon.575b61d7.svg";
export { ForwardRef as ReactComponent };